import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectChecklist } from 'next/entities/checklists';
import { ConditionText } from './styled';

const CHECKLIST_STATUS_NAMES = {
  in_progress: 'be in progress',
  skipped: 'have been skipped',
  'completed\ndismissed': 'have been completed',
};

export const ChecklistCondition = ({
  status,
  checklistName,
  checklist: checklistId,
}) => {
  return (
    <ConditionText>
      checklist {checklistName || checklistId} must{' '}
      {CHECKLIST_STATUS_NAMES[status] || 'not have been seen'}
    </ConditionText>
  );
};

ChecklistCondition.propTypes = {
  status: PropTypes.string,
  checklistName: PropTypes.string,
  checklist: PropTypes.string,
};

const mapStateToProps = (state, { checklist: checklistId }) => {
  return {
    checklistName: selectChecklist(state, checklistId)?.internalName,
  };
};

export default connect(mapStateToProps)(ChecklistCondition);
